// extracted by mini-css-extract-plugin
module.exports = {"centered":"centered___1sWNF","social":"social___ewP_P"};